<div class="event-info-container">
  @if (loading) {
  <div class="loading">Indlæser...</div>
  } @if (error) {
  <div class="error">{{ error }}</div>
  } @if (!loading && !error && event) {
  <div class="event-info">
    <div class="event-header">
      <div class="event-title-section">
        <span class="event-type-badge" [class]="'badge-' + event.event_type">
          {{ getEventTypeName(event.event_type) }}
        </span>
        <h3 class="event-title">
          {{
            event.description.short_description["da"]?.translation_text ||
              "Ingen titel"
          }}
        </h3>
      </div>
      <div class="event-status">
        <span
          class="status-badge"
          [class.active]="event.is_active"
          [class.inactive]="!event.is_active"
        >
          {{ event.is_active ? "Aktiv" : "Inaktiv" }}
        </span>
        <span
          class="status-badge"
          [class.shown]="event.is_shown"
          [class.hidden]="!event.is_shown"
        >
          {{ event.is_shown ? "Vist" : "Skjult" }}
        </span>
      </div>
    </div>
    <div class="event-meta">
      <div class="meta-item">
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <span
          >{{ formatDate(event.start_date) }} →
          {{ formatDate(event.end_date) }}</span
        >
      </div>
      @if (getLocationName() !== 'Ikke angivet') {
      <div class="meta-item">
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
        <span
          >{{ getLocationName() }}@if (getRoomName()) {
          <span> - {{ getRoomName() }}</span>
          }</span
        >
      </div>
      } @if (event.organization) {
      <div class="meta-item">
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
        <span>{{ event.organization.org_name }}</span>
      </div>
      }
      <div class="meta-item">
        <svg
          class="icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
        <span
          >{{ getVisibilityName(event.visibility) }} •
          {{ getCateringName(event.catering) }}@if (event.price) {
          <span> • {{ event.price }} kr.</span>
          }</span
        >
      </div>
    </div>
  </div>
  }
</div>
